import { isHTMLElement } from '../../utilities/dom.mjs';

const selectors = ['button', 'a'];
function getInteractiveElement(node) {
  if (!node) {
    return undefined;
  }
  for (const selector of selectors) {
    const child = node.querySelector(selector);
    if (isHTMLElement(child)) {
      return child;
    } else {
      const parent = node.closest(selector);
      if (isHTMLElement(parent)) {
        return parent;
      }
    }
  }
  return undefined;
}
function getSelectedItemNode(options, selectedIndex) {
  if (selectedIndex === -1) {
    return undefined;
  }
  const selectedItem = Array.from(options.values()).find(option => option.index.current === selectedIndex);
  return selectedItem == null ? void 0 : selectedItem.node.current;
}
function getAnnouncementForElement(interactiveElement) {
  var _interactiveElement$g;
  if (!interactiveElement) {
    return undefined;
  }
  const announcement = (_interactiveElement$g = interactiveElement.getAttribute('aria-label')) != null ? _interactiveElement$g : interactiveElement.innerText;
  return announcement;
}

export { getAnnouncementForElement, getInteractiveElement, getSelectedItemNode };
